import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useTheme } from "@client/components/ThemeProvider";

/**
 * Rewired from April's version, which read the theme from next-themes. We have our own ThemeProvider,
 * so this drops that dependency and resolves "system" here rather than passing it through.
 */
export function Toaster(props: ToasterProps) {
  const { theme } = useTheme();
  const resolved: "light" | "dark" =
    theme === "system"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
      : theme;

  return (
    <Sonner
      theme={resolved}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-raised",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}
